/**
 * Configurações de animações sutis e rápidas para todo o sistema
 */

// Transições base para elementos interativos
export const baseTransitions = {
  fast: 'transition-all duration-150 ease-out',
  normal: 'transition-all duration-200 ease-out',
  slow: 'transition-all duration-300 ease-out',
};

// Animações de entrada para componentes
export const entranceAnimations = {
  fadeIn: 'opacity-0 animate-[fadeIn_0.2s_ease-out_forwards]',
  slideInFromTop: 'opacity-0 animate-[slideInFromTop2_0.2s_ease-out_forwards]',
  slideInFromLeft: 'opacity-0 animate-[slideInFromLeft2_0.2s_ease-out_forwards]',
  slideInFromRight: 'opacity-0 animate-[slideInFromRight2_0.2s_ease-out_forwards]',
  slideInFromBottom: 'opacity-0 animate-[slideInFromBottom2_0.2s_ease-out_forwards]',
  scaleIn: 'opacity-0 animate-[zoomIn95_0.2s_ease-out_forwards]',
};

// Animações de hover para elementos interativos
export const hoverAnimations = {
  lift: 'hover:-translate-y-0.5 hover:shadow-lg',
  scale: 'hover:scale-105',
  glow: 'hover:shadow-lg hover:shadow-teal-200/50',
  borderGlow: 'hover:border-teal-300 hover:shadow-teal-200/50',
};

// Animações para cards e elementos de lista
export const cardAnimations = {
  stagger: 'opacity-0 animate-[slideInFromBottom2_0.2s_ease-out_forwards]',
  hover: 'hover:-translate-y-1 hover:shadow-lg transition-all duration-200',
  focus: 'focus:ring-2 focus:ring-teal-500 focus:ring-offset-2',
};

// Animações para botões
export const buttonAnimations = {
  press: 'active:scale-95 transition-transform duration-75',
  hover: 'hover:scale-105 transition-transform duration-150',
  ripple: 'relative overflow-hidden',
};

// Animações para formulários
export const formAnimations = {
  fieldFocus: 'focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-all duration-200',
  fieldError: 'animate-pulse border-red-300',
  fieldSuccess: 'border-green-300 shadow-green-100',
};

// Animações para notificações e mensagens
export const notificationAnimations = {
  slideIn: 'opacity-0 animate-[slideInFromTop2_0.3s_ease-out_forwards]',
  slideOut: 'opacity-0 animate-[slideOutToTop2_0.3s_ease-out_forwards]',
  bounce: 'opacity-0 animate-[bounceIn_0.3s_ease-out_forwards]',
};

// Animações para loading e estados
export const loadingAnimations = {
  spin: 'animate-spin',
  pulse: 'animate-pulse',
  bounce: 'animate-bounce',
  ping: 'animate-ping',
};

// Animações para transições de página
export const pageTransitions = {
  fadeIn: 'opacity-0 animate-[fadeIn_0.3s_ease-out_forwards]',
  slideIn: 'opacity-0 animate-[slideInFromRight2_0.3s_ease-out_forwards]',
  scaleIn: 'opacity-0 animate-[zoomIn95_0.3s_ease-out_forwards]',
};

// Animações para elementos de navegação
export const navigationAnimations = {
  active: 'scale-105 shadow-lg',
  hover: 'hover:scale-105 hover:shadow-md transition-all duration-150',
  focus: 'focus:scale-105 focus:shadow-lg transition-all duration-150',
};

// Animações para elementos de dados
export const dataAnimations = {
  rowHover: 'hover:bg-slate-50 transition-colors duration-150',
  cellFocus: 'focus:bg-teal-50 focus:outline-none focus:ring-2 focus:ring-teal-500',
  selection: 'bg-teal-50 border-teal-200 transition-all duration-150',
};

// Animações para modais e overlays
export const modalAnimations = {
  backdrop: 'opacity-0 animate-[fadeIn_0.2s_ease-out_forwards]',
  content: 'opacity-0 animate-[zoomIn95_0.2s_ease-out_forwards] animate-[slideInFromBottom2_0.2s_ease-out_forwards]',
  close: 'opacity-0 animate-[zoomOut95_0.2s_ease-out_forwards] animate-[slideOutToBottom2_0.2s_ease-out_forwards]',
  sidebarSlideIn: 'translate-x-full animate-[slideInFromRight_0.3s_ease-out_forwards]',
};

// Animações para elementos de status
export const statusAnimations = {
  success: 'opacity-0 animate-[zoomIn95_0.2s_ease-out_forwards]',
  error: 'opacity-0 animate-[shakeX_0.2s_ease-out_forwards]',
  warning: 'opacity-0 animate-[pulse_0.2s_ease-out_forwards]',
  info: 'opacity-0 animate-[fadeIn_0.2s_ease-out_forwards]',
};
